import React from "react";

interface ValuesListEditorProps {
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  label?: string;
}

export default function ValuesListEditor({
  values = [],
  onChange,
  placeholder = "Enter value",
  label = "Values",
}: ValuesListEditorProps) {
  const addValue = () => {
    onChange([...values, ""]);
  };

  const updateValue = (index: number, value: string) => {
    const newValues = [...values];
    newValues[index] = value;
    onChange(newValues);
  };

  const removeValue = (index: number) => {
    const newValues = values.filter((_, i) => i !== index);
    onChange(newValues);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-xs text-gray-600">{label}</label>
        <button
          type="button"
          className="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
          onClick={addValue}
        >
          Add Value
        </button>
      </div>

      {values.length === 0 ? (
        <div className="text-xs text-gray-500 italic">No values added yet</div>
      ) : (
        <div className="space-y-2">
          {values.map((value, index) => (
            <div key={index} className="flex items-center gap-2">
              <input
                type="text"
                className="flex-1 border rounded px-2 py-1 text-sm"
                value={value}
                onChange={(e) => updateValue(index, e.target.value)}
                placeholder={placeholder}
              />
              <button
                type="button"
                className="px-2 py-1 text-xs bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => removeValue(index)}
                title="Remove value"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
